module.exports = __webpack_public_path__ + "img/mashroom.1792a37a.jpg";